import { useState } from 'react';
import { useSearch } from 'react-location';
import { useOnlineHotlineAvailable } from '../modules/datastores/useEntryPoint';
import TOSHotlineInfo from '../components/landing/TOSHotlineInfo';
import TOSMoreInfo from '../components/landing/TOSMoreInfo';
import TOSFooter from '../components/landing/TOSFooter';
import { useGetClientInfo } from '../modules/datastores/useGetClientInfo';
import type { HotlinePageData } from '../modules/algebra/global';
import TOSHeader from '../components/landing/TOSHeader';
import TOSTermsBanner from '../components/landing/TOSTermsBanner';
import TOSAdditionalInformation from '../components/landing/TOSAdditionalInformation';
import { CircularProgress } from '@mui/material';
/**
 * This is the TOS Page - its only for RAINN - diff people will have diff pages.
 */
const TOSPage: React.FC = () => {
  const query = useSearch();
  const messaging_service_key = query['messaging_service_key'] as string;
  const statusQuery = useOnlineHotlineAvailable(`${messaging_service_key}`);
  const data = useGetClientInfo(`${messaging_service_key}`);
  const pageData = data.data || ({} as HotlinePageData);
  const [additionalContent, setAdditionalContent] = useState('');

  return (
    <>
      <head>
        <title>Terms Of Service - Online Hotline</title>
      </head>
      {data.isLoading ? (
        <CircularProgress />
      ) : (
        <div className="tos-hotline-page">
          <TOSHeader pageData={pageData} />
          <TOSTermsBanner statusQuery={statusQuery} pageData={pageData} />
          <TOSHotlineInfo pageData={pageData} setAdditionalContent={setAdditionalContent} />
          <TOSMoreInfo pageData={pageData} />
          {additionalContent && <TOSAdditionalInformation content={additionalContent} setAdditionalContent={setAdditionalContent} />}
          <TOSFooter pageData={pageData} />
        </div>
      )}
    </>
  );
};

export default TOSPage;
